import {  BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from "./NavBar";
import Home from './Home';
import About from './About';
import Project from './Project';
import './App.css';
import Contact from './Contact';

function App() {
  return (
      <Router>
      <NavBar/>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/about' element={<About/>} />
          <Route path='/project' element={<Project/>} />
          <Route path='/contact' element={<Contact/>} />
        </Routes>
      </Router>
  );
}

export default App;